module.exports = __webpack_public_path__ + "static/media/smart_digital.0a66a25f.png";